class BluetoothClass {
	private readonly FRAME_SERVICE_UUID = '0492fcec-7194-11eb-9439-0242ac130002';
	private readonly FRAME_CONTROL_UUID = '0492fcec-7194-11eb-9439-0242ac130003';

	public connected = $state(false);
	public pairing = $state(false);
	public writing = $state(false);
	public reading = $state(false);
	public ready = $derived(this.connected && !this.pairing && !this.writing && !this.reading);

	private device: BluetoothDevice | undefined;
	private server: BluetoothRemoteGATTServer | undefined;
	private service: BluetoothRemoteGATTService | undefined;
	private characteristic: BluetoothRemoteGATTCharacteristic | undefined;

	private readonly textEncoder = new TextEncoder();

	constructor() {}

	public connect = async () => {
		try {
			this.connected = false;
			this.pairing = false;
			this.device = await navigator.bluetooth.requestDevice({ filters: [{ services: [this.FRAME_SERVICE_UUID] }] });
			this.pairing = true;

			if (!this.device.gatt) throw new Error('No GATT server on device');

			this.server = await this.device.gatt.connect();
			this.connected = true;

			this.service = await this.server.getPrimaryService(this.FRAME_SERVICE_UUID);
			this.characteristic = await this.service.getCharacteristic(this.FRAME_CONTROL_UUID);
			this.pairing = false;
		} catch (err) {
			this.pairing = false;
			throw err;
		}
	};

	public write = async (data: string) => {
		try {
			if (!this.connected) throw new Error('Attempted to write to Bluetooth without connection');
			if (!this.characteristic) throw new Error('Attempted to write to Bluetooth without characteristic');
			this.writing = true;
			await this.characteristic.writeValue(this.textEncoder.encode(data));
			this.writing = false;
		} catch (err) {
			this.writing = false;
			throw err;
		}
	};

	public read = async () => {
		try {
			if (!this.connected) throw new Error('Attempted to read from Bluetooth without connection');
			if (!this.characteristic) throw new Error('Attempted to read from Bluetooth without characteristic');
			this.reading = true;
			const val = await this.characteristic.readValue();
			this.reading = false;
			return val;
		} catch (err) {
			this.reading = false;
			throw err;
		}
	};
}

export const Bluetooth = new BluetoothClass();
